import React from 'react';

import styled from 'styled-components';

import IconAmex from 'components/icons/amex';
import IconApplePay from 'components/icons/applepay';
import IconDiscover from 'components/icons/discover';
import IconGooglePay from 'components/icons/google-pay';
import IconMastercard from 'components/icons/mastercard';
import IconPaypal from 'components/icons/paypal';
import IconVisa from 'components/icons/visa';
import { CardTypes } from 'state/payment/types';
import { mapPaymentMethodCardTypes } from 'utils/payment/map-payment-method-card-type';

const BlankCard = styled.div`
  background-color: ${Styles.color.grey.four};
  height: 1.2rem;
  width: 1.6rem;
`;

export const cardIconRenderer = (methodType: string): JSX.Element => {
  const cardType = mapPaymentMethodCardTypes(methodType);
  if (!cardType) {
    return <BlankCard />;
  }
  return {
    [CardTypes.VISA]: <IconVisa />,
    [CardTypes.MASTERCARD]: <IconMastercard />,
    [CardTypes.AMEX]: <IconAmex />,
    [CardTypes.DISCOVER]: <IconDiscover />,
    [CardTypes.APPLE_PAY]: <IconApplePay />,
    [CardTypes.GOOGLE_PAY]: <IconGooglePay />,
    [CardTypes.PAYPAL]: <IconPaypal />,
  }[cardType];
};
